import { Routes } from '@angular/router'
import { isUserAuthenticatedGuard } from '@core/guards/is-user-authenticated.guard'
import { isUserUnauthenticatedGuard } from '@core/guards/is-user-unauthenticated.guard'
import { LayoutComponent } from './layout/layout.component'
import { requirementsGuard } from '@core/guards/requirements.guard'
import { canAccessBig5 } from '@big5/guards/can-access-big5.guard'

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [isUserAuthenticatedGuard],
    canActivateChild: [requirementsGuard],
    children: [
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadComponent: () => import('./pages/home-page/home-page.component').then(c => c.HomePageComponent),
        data: {
          nav: 'resumen',
          preload: true
        }
      },
      {
        path: 'autoejecucion',
        loadChildren: () => import('./modules/autoejecucion/autoejecucion.routes').then(m => m.routes)
      },
      {
        path: 'adds',
        loadChildren: () => import('./modules/adds/adds.routes').then(m => m.routes)
      },
      {
        path: 'kpis',
        loadChildren: () => import('./modules/kpis/kpis.routes').then(m => m.routes)
      },
      {
        path: 'big5',
        loadChildren: () => import('./modules/big5_v2/big5.routes').then(m => m.routes),
        data: {
          preload: true
        },
        canActivate: [canAccessBig5]
      },
      {
        path: 'metas',
        loadChildren: () => import('./modules/bonificaciones/bonificaciones.routes').then(m => m.routes)
      },
      {
        path: 'quinela',
        loadChildren: () => import('./modules/quinela/quinela.routes').then(m => m.routes)
      },
      {
        path: 'novedades',
        loadChildren: () => import('./modules/novedades/novedades.routes').then(m => m.routes)
      },
      {
        path: 'hoja-unica',
        loadChildren: () => import('./modules/hoja-unica/hoja-unica.routes').then(m => m.routes),
        data: {
          preload: true
        }
      },
      {
        path: 'club_modelorama',
        loadChildren: () => import('./modules/club-modelorama/club-modelorama.routes').then(m => m.routes)
      },
      {
        path: 'tiendas_perfectas',
        loadChildren: () => import('./modules/tiendas-perfectas/tiendas-perfectas.routes').then(m => m.routes)
      },
      {
        path: 'participant',
        loadChildren: () => import('./modules/participant/participant.routes').then(m => m.routes)
      },
      {
        path: 'pos',
        loadChildren: () => import('./modules/pos/pos.routes').then(m => m.routes)
      },
      {
        path: 'radiografia',
        loadChildren: () => import('./modules/radiografia/radiografia.routes').then(m => m.routes)
      },
      {
        path: 'precios_sugeridos',
        loadChildren: () => import('./modules/precios_sugeridos/precios_sugeridos.routes').then(m => m.routes)
      },
      {
        path: 'socios_comerciales',
        loadComponent: () => import('./pages/socios-comerciales-page/socios-comerciales-page.component').then(c => c.SociosComercialesPageComponent)
      },
      {
        path: 'modelorama',
        loadComponent: () => import('./pages/modelorama-escuela-page/modelorama-escuela-page.component').then(c => c.ModeloramaEscuelaPageComponent)
      },
      {
        path: 'referral',
        loadComponent: () => import('./pages/referrals-page/referrals-page.component').then(c => c.ReferralsPageComponent)
      },
      {
        path: 'preguntas_frecuentes',
        loadComponent: () => import('./pages/preguntas-frecuentes-page/preguntas-frecuentes-page.component').then(c => c.PreguntasFrecuentesPageComponent)
      },
      {
        path: 'guia',
        loadComponent: () => import('./pages/support-guide-page/support-guide-page.component').then(c => c.SupportGuidePageComponent)
      },
      {
        path: 'descargas',
        loadComponent: () => import('./pages/downloads-page/downloads-page.component').then(c => c.DownloadsPageComponent)
      },
      {
        path: 'alerta_modelorama',
        loadComponent: () => import('./pages/alerta-modelorama-page/alerta-modelorama-page.component').then(c => c.AlertaModeloramaPageComponent)
      },
      {
        path: 'termometro',
        loadChildren: () => import('./modules/termometro/termometro.routes').then(m => m.routes)
      }
    ]
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.routes').then(m => m.routes),
    canActivate: [isUserUnauthenticatedGuard]
  },
  {
    path: 'complete_signup',
    canActivate: [isUserAuthenticatedGuard],
    loadComponent: () => import('@auth/pages/complete-signup-page/complete-signup-page.component').then(c => c.CompleteSignupPageComponent)
  },
  {
    path: 'tos',
    loadComponent: () => import('./pages/terms-page/terms-page.component').then(c => c.TermsPageComponent),
    canActivate: [isUserAuthenticatedGuard]
  },
  {
    path: '404',
    loadComponent: () => import('./pages/unknown-page/unknown-page.component').then(c => c.UnknownPageComponent)
  },
  {
    path: '**',
    redirectTo: '/404'
  }
]
